
import { CheckCircleOutlined } from '@ant-design/icons-vue';

export default {
  components: {
    CheckCircleOutlined
  }
};
